module.exports = __webpack_public_path__ + "media/images/app/forced-modal-dd52a922852d7f9ea4a1f9e2b53ad0b1.svg";